import { EventEmitter } from "@angular/core";
import { Injectable } from "@angular/core";
import { BaseModel } from "../../models/base-model";
import { HttpService } from "../../../services/http.service";
import { LocationVO } from "../../vo/geo-location";
import { NotifierService } from "../../../services/notifierService/notifier.service";
import { ApplicationModel } from "../../models/application.model";
import { TrackingManager } from "../../tracking/tracking-manager";

@Injectable()
export class GeoLocationModelService extends NotifierService {
	private locationMenuXML: any;
	public locationList: any[];
	private locationStyleFilePath: string;
	private headerText: string;
	private termsText: string;
	private uHaveChosenText: string;
	private printedText: string;
	private printBtnLabel: string;
	private backBtnLabel: string;
	private iAgreeBtnLabel: string;
	private availableLocations: string;
	public selectedGeoLocation: LocationVO;
	private showGeoLocationPopup: boolean;
	private singleLocation: string;
	public singleLocEvent = new EventEmitter();
	public isConfirmationScreen = false;
	private bshow: boolean = false;
	public showDropdown: boolean = true;
	public hideGeolocation = false;
	public textDirection = "";

	constructor(private httpService: HttpService) {
		super();
		this.showGeoLocationPopup = false;
		this.singleLocation = "";
	}

	public initialize(location_xml, availableLocations) {
		this.singleLocation =
			availableLocations.split(",").length > 1
				? ""
				: availableLocations.split(",")[0];
		if (!this.hideGeolocation) this.showGeoLocation = true;
		this.availableLocations = availableLocations;
		this.loadXml(location_xml);
		this.textDirection = ApplicationModel.instance.flowDirection;
	}
	private loadXml(url) {
		this.httpService.getXmlData(url).then((res: any) => {
			this.locationMenuXML = res;
			console.log("geolocationModelService >> loadXml", this.locationMenuXML);
			this.parseXml();
			this._notifier.next("data");
		});
	}
	private parseXml() {
		let count = 0;
		let countLen = this.locationMenuXML.childNodes[0].childNodes.length;
		let nodeName;
		for (count = 0; count < countLen; ++count) {
			nodeName = this.locationMenuXML.childNodes[0].childNodes[count].nodeName;
			switch (nodeName.toLowerCase()) {
				case "filePath":
					this.locationStyleFilePath =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "locations":
					this.parseLocationList(
						this.locationMenuXML.childNodes[0].childNodes[count]
					);
					break;
				case "header":
					this.headerText =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "terms":
					this.termsText =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "uhavechosen":
					this.uHaveChosenText =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "printed":
					this.printedText =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "print":
					this.printBtnLabel =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "back":
					this.backBtnLabel =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
				case "iagree":
					this.iAgreeBtnLabel =
						this.locationMenuXML.childNodes[0].childNodes[count].textContent;
					break;
			}
		}
	}
	private parseLocationList(locationList) {
		let count = 0;
		let countLen = locationList.childNodes.length;
		let nodeName;
		let locationVO;
		let locationID;
		this.locationList = [];
		for (count = 0; count < countLen; ++count) {
			nodeName = locationList.childNodes[count].nodeName;
			switch (nodeName.toLowerCase()) {
				case "geolocation":
					locationID =
						locationList.childNodes[count].getAttributeNode("abbr").nodeValue;
					if (
						this.locationList[locationID] === undefined &&
						this.availableLocations.indexOf(locationID.toLowerCase()) >= 0
					) {
						locationVO = new LocationVO();
						locationVO.id = locationID;
						locationVO.label = locationList.childNodes[count].textContent;
						//this.locationList[locationID] = locationVO;
						this.locationList.push(locationVO);
					}

					break;
			}
		}
		if (this.locationList.length > 6) {
			this.bshow = true;
		}

		if (this.singleLocation !== "") {
			this.selectedGeoLocation = this.locationList.find(
				(location) =>
					location.id.toLowerCase === this.singleLocation.toLowerCase
			);
			this.singleLocEvent.emit("singleLocation loaded");
		}
		//
		//console.log("Geolocation ", TrackingManager.instance.trackingVO);
		if (TrackingManager.instance.trackingVO["geoLocation"]) {
			this.selectedGeoLocation = this.locationList.find(
				(location) =>
					location.id == TrackingManager.instance.trackingVO["geoLocation"]
			);
			console.log("Set Geolocation ", this.selectedGeoLocation);
			this._notifier.next("locationSet");
		}
	}

	public isSingleLocation() {
		return this.singleLocation !== "" ? true : false;
	}

	public get showGeoLocation() {
		return this.showGeoLocationPopup;
	}
	public set showGeoLocation(val) {
		this.showGeoLocationPopup = val;
	}

	public get dialogueHeaderText() {
		return this.uHaveChosenText;
	}
}
